import { api } from '../../api'
import { useCurrentId } from '../../hooks'
import { $conversations } from '../../model/stores'

export function useRead() {
	const id = useCurrentId()

	const [readMutation] = api.useMarkReadMutation()

	return () => {
		const map = $conversations.get()
		const conversation = map[id]

		if (conversation?.unread_count) {
			readMutation({ id, mark: true })
		}
	}
}
